import axios from "axios";
import { authHeaderJson } from "../auth-header.service";
import { requestExportToken } from "../export.service";


const getAllMessageEventByBookAndMessage = (bookId, messageId) => {
    return axios.get(`/api/SbMessage/messagesEventsBook/${ bookId }/${ messageId }/list`, { headers: authHeaderJson() } )
};

const getAllMessageEventByBookAndMessageExcelData = async (bookId, messageId) => {
    const token = await requestExportToken("messagesEventsBookExcelData");
    return axios.get(
        `/api/SbMessage/messagesEventsBookExcelData/${bookId}/${messageId}/list?exportToken=${token}`,
        { headers: authHeaderJson() }
    );
};

const getEventHomeLast = (numberOfEvent) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SbHome/eventHomeLast/${numberOfEvent}`, { headers: authHeaderJson() } )
};

const saveMessageComment = (messageObject) => {
    return axios.post(`/api/SbMessage/messageCommentadd`, messageObject, { headers: authHeaderJson() } )
};


const getExportBookPdfMessages = async (bookId, partyMemberId, messageId) => {
    const token = await requestExportToken("messagesBook/pdf");
    return axios.get(
        `/api/SbMessage/messagesBook/${bookId}/${partyMemberId}/${messageId}/list/pdf?exportToken=${token}`,
        { headers: authHeaderJson() }
    );
};

const getMessageComments = (bookId, messageId) => {
    return axios.get(`/api/sbMessage/messagesCommentsBook/${bookId}/${messageId}/list`, { headers: authHeaderJson() } )
};


export {
    getAllMessageEventByBookAndMessage,
    getAllMessageEventByBookAndMessageExcelData,
    getEventHomeLast,
    saveMessageComment,
    getExportBookPdfMessages,
    getMessageComments
}